/**
 * Converts seconds to hours, rounded up to decimal scale of 1
 *
 * @example
 * // returns 1
 * secondsToHours(3600);
 * @example
 * // returns 0.1
 * secondsToHours(1);
 * @example
 * // returns 0.2
 * secondsToHours(361);
 * @example
 * // returns 0.11
 * secondsToHours(361, 2);
 * @example
 * // returns 0.25
 * secondsToHours(900, 2);
 * @example
 * // returns 0.3
 * secondsToHours(900);
 * @param seconds - duration in seconds
 * @param decimalScale - decimal precision, power of 10
 * @returns duration in hours
 */
export const secondsToHours = (seconds: number, decimalScale: number = 1): number => {
    return Math.ceil((Math.pow(10, decimalScale) * seconds) / 3600) / Math.pow(10, decimalScale);
};

export const hoursToSeconds = (hours: number): number => {
    return hours * 3600;
};
